module.exports = __webpack_public_path__ + "img/Плечелопаточный периартрит.5f341ade.jpg";